import { Component, OnInit } from '@angular/core';
import { EventService } from 'app/core/services/event.service';
import { LayoutSettings, LayoutSettingsService } from 'app/core/services/layout-settings.service';

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss'],
})
export class RightsidebarComponent implements OnInit {
  topbar: string | undefined;
  sidebarcolor: string | undefined;
  direction: string | undefined;

  constructor(
    private eventService: EventService,
    private _layout: LayoutSettingsService,
  ) {}

  ngOnInit(): void {
    const settingsFromCookie: LayoutSettings = this._layout.getCurrentLayoutSettings();
    this.topbar = settingsFromCookie.topbar;
    this.sidebarcolor = settingsFromCookie.sidebarcolor;
    this.direction = settingsFromCookie.direction;
  }
  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  changeMode(mode: string) {
    this.sidebarcolor = mode;
    this.topbar = mode;
    this.eventService.broadcast('changeMode', mode);
  }

  changeDirection(direction: string) {
    this.direction = direction;
    this.eventService.broadcast('changeDirection', direction);
  }

  changeTopbar(topbar: string) {
    this.topbar = topbar;
    this.eventService.broadcast('changeTopbar', topbar);
  }

  changeSidebarColor(sidebarcolor: string) {
    this.sidebarcolor = sidebarcolor;
    this.eventService.broadcast('changeSidebarColor', sidebarcolor);
  }
}
